module.exports = __webpack_public_path__ + "media/images/bornachot-hover-8b17276ef705b633082de9010775d9c3.jpg";